/* 用户管理 */
const UserManage = () => import('../pages/user/index.vue') // 用户管理
const UserManageList = () => import('../pages/user/component/index.vue') // 用户管理 -> 列表

/* 设备管理 */
const facilityManage = () => import('../pages/facility/index.vue') // 设备管理
const facilityManageList = () => import('../pages/facility/component/list.vue') // 设备管理 -> 列表

/* 安全监控 */
const safetyManage = () => import('../pages/safety/index.vue') // 安全监控
const safetyManageSos = () => import('../pages/safety/component/sos.vue') // 安全监控 -> Sos一键求救

/* 故障管理 */
const faultManage = () => import('../pages/fault/index.vue') // 故障管理
const faultManageList = () => import('../pages/fault/component/list.vue') // 故障管理 -> 故障码列表
const faultManageStats = () => import('../pages/fault/component/stats.vue') // 故障管理 -> 故障统计
const faultManageAdd = () => import('../pages/fault/component/add.vue') // 故障管理 -> 故障码新增


/* 电商管理 */
const commerceManage = () => import('../pages/commerce/index.vue') // 电商管理

const commerceManageBanner = () => import('../pages/commerce/component/banner.vue') // 电商管理 -> 轮播图
const commerceManageHomeVideo = () => import('../pages/commerce/component/home-video.vue') // 电商管理 -> 首页视频
const commerceManageProductDisplay = () => import('../pages/commerce/component/product-display.vue') // 电商管理 -> 橱窗管理
const commerceManageContactMessage = () => import('../pages/commerce/component/contact-message.vue') // 电商管理 -> 合作留言

const commerceManageFreight = () => import('../pages/commerce/component/freight.vue') // 电商管理 -> 运费
const commerceManageFreightAdd = () => import('../pages/commerce/component/freight-add.vue') // 电商管理 -> 运费 -> 新增运费模板

const commerceManageClassfiy = () => import('../pages/commerce/component/classfiy.vue') // 电商管理 -> 分类

const commerceManageCommodity = () => import('../pages/commerce/component/commodity.vue') // 电商管理 -> 商品管理
const commerceManageCommodityAdd = () => import('../pages/commerce/component/commodity-add.vue') // 电商管理 -> 商品管理

const commerceManageOrder = () => import('../pages/commerce/component/order.vue') // 电商管理 -> 订单管理


/* */
const SystemManage = () => import('../pages/system/index.vue') // 系统管理

const SystemManageRole = () => import('../pages/system/component/role.vue') // 系统管理 -> 角色管理

const SystemManageJurisdiction = () => import('../pages/system/component/jurisdiction.vue') // 系统管理 -> 权限管理

// const SystemManageLog = () => import('../pages/system/component/log')// 系统管理 -> 操作日志

/* 需要权限判断的路由 */
const dynamicRoutes = [
    //--------用户管理
    {
        path: '/user',
        component: UserManage,
        name: 'user',
        title: '用户管理',
        meta: {
            name: '用户管理',
            icon: require('@/assets/images/icon/user0.png')
        },
        children: [
            {
                path: 'list',
                name: 'user-list',
                component: UserManageList,
                title: '用户列表',
                meta: {
                    name: '用户列表',
                    parentName: '用户管理',
                    icon: require('@/assets/images/icon/user1.png')
                },
            },
        ]
    },
    //--------设备管理
    {
        path: '/facility',
        component: facilityManage,
        name: 'facility',
        title: '设备管理',
        meta: {
            name: '设备管理',
            icon: require('@/assets/images/icon/facility0.png')
        },
        children: [
            {
                path: 'list',
                name: 'facility-list',
                component: facilityManageList,
                title: '设备列表',
                meta: {
                    name: '设备列表',
                    parentName: '设备管理',
                    icon: require('@/assets/images/icon/facility0.png')
                },
            },
        ]
    },
    //--------安全监控
    {
        path: '/safety',
        component: safetyManage,
        name: 'safety',
        title: '安全监控',
        meta: {
            name: '安全监控',
            icon: require('@/assets/images/icon/safety0.png')
        },
        children: [
            {
                path: 'sos',
                name: 'safety-sos',
                component: safetyManageSos,
                title: 'SoS一键求救',
                meta: {
                    name: 'SoS一键求救',
                    parentName: '安全监控',
                    icon: require('@/assets/images/icon/safety0.png')
                },
            },
        ]
    },
    //--------故障管理
    {
        path: '/fault',
        component: faultManage,
        name: 'fault',
        title: '故障管理',
        meta: {
            name: '故障管理',
            icon: require('@/assets/images/icon/fault0.png')
        },
        children: [
            {
                path: 'list',
                name: 'fault-list',
                component: faultManageList,
                title: '故障码列表',
                meta: {
                    name: '故障码列表',
                    parentName: '故障管理',
                    icon: require('@/assets/images/icon/fault1.png')
                },
            },
            {
                path: 'stats',
                name: 'fault-stats',
                component: faultManageStats,
                title: '故障统计',
                meta: {
                    name: '故障统计',
                    parentName: '故障管理',
                    icon: require('@/assets/images/icon/fault2.png')
                },
            },
            {
                path: 'add',
                name: 'fault-add',
                component: faultManageAdd,
                title: '新增故障教程',
                meta: {
                    name: '新增故障教程',
                    parentName: '故障管理',
                    icon: require('@/assets/images/icon/fault1.png')
                },
                type: 1
            },
        ]
    },
    //--------电商管理
    {
        path: '/commerce',
        component: commerceManage,
        name: 'commerce',
        title: '电商管理',
        meta: {
            name: '电商管理',
            icon: require('@/assets/images/icon/commerce0.png')
        },
        children: [

            {
                path: 'banner',
                name: 'commerce-banner',
                component: commerceManageBanner,
                title: '首页Banner',
                meta: {
                    name: '首页Banner',
                    parentName: '电商管理',
                    icon: require('@/assets/images/icon/commerce1.png')
                },
            },
            {
                path: 'home-video',
                name: 'commerce-home-video',
                component: commerceManageHomeVideo,
                title: '首页视频轮播',
                meta: {
                    name: '首页视频轮播',
                    parentName: '电商管理',
                    icon: require('@/assets/images/icon/commerce1.png')
                },
            },
            {
                path: 'classfiy',
                name: 'commerce-classfiy',
                component: commerceManageClassfiy,
                title: '产品类型',
                meta: {
                    name: '产品类型',
                    parentName: '电商管理',
                    icon: require('@/assets/images/icon/commerce3.png')
                },
            },
            {
                path: 'commodity',
                name: 'commerce-commodity',
                component: commerceManageCommodity,
                title: '商品管理',
                meta: {
                    name: '商品管理',
                    parentName: '电商管理',
                    icon: require('@/assets/images/icon/commerce4.png')
                },
            },
            {
                path: 'commodity-add',
                name: 'commerce-commodity-add',
                component: commerceManageCommodityAdd,
                title: '商品管理-新增',
                meta: {
                    name: '商品管理-新增',
                    parentName: '电商管理',
                    icon: require('@/assets/images/icon/commerce4.png')
                },
                type: 1
            },
            {
                path: 'product-display',
                name: 'commerce-product-display',
                component: commerceManageProductDisplay,
                title: '橱窗管理',
                meta: {
                    name: '橱窗管理',
                    parentName: '电商管理',
                    icon: require('@/assets/images/icon/commerce1.png')
                },
            },
            {
                path: 'contact-message',
                name: 'commerce-contact-message',
                component: commerceManageContactMessage,
                title: '合作留言',
                meta: {
                    name: '合作留言',
                    parentName: '电商管理',
                    icon: require('@/assets/images/icon/commerce1.png')
                },
            },
            {
                path: 'order',
                name: 'commerce-order',
                component: commerceManageOrder,
                title: '订单管理',
                meta: {
                    name: '订单管理',
                    parentName: '电商管理',
                    icon: require('@/assets/images/icon/commerce5.png')
                },
            },
        ]
    },
    //--------系统管理
    {
        path: '/system',
        component: SystemManage,
        name: 'system',
        title: '系统管理',
        meta: {
            name: '系统管理',
            icon: require('@/assets/images/icon/system0.png')
        },
        children: [
            {
                path: 'role',
                name: 'system-role',
                component: SystemManageRole,
                title: '角色管理',
                meta: {
                    name: '角色管理',
                    parentName: '系统管理',
                    icon: require('@/assets/images/icon/system1.png')
                }
            },
            {
                path: 'jurisdiction',
                name: 'system-jurisdiction',
                component: SystemManageJurisdiction,
                title: '权限管理',
                meta: {
                    name: '权限管理',
                    parentName: '系统管理',
                    icon: require('@/assets/images/icon/system2.png')
                }
            },


            // {
            //     path: 'log',
            //     name: 'system-log',
            //     component: SystemManageLog,
            //     title: '操作日志',
            //     meta: {
            //         name: '操作日志',
            //         icon: 'el-icon-s-home'
            //     }
            // },
        ]
    },
]

export default dynamicRoutes
